<div class="row h-100 justify-content-center " [dir]="this.app.getUserDire()">
    <div class="col-4">
        <div class="bgWhite p-3 h-100">

            <!-- post header -->
            <div class="d-flex justify-content-between">
                <div>
                    <mat-icon (click)="cancel()" class="cancelBtn mainColor pointer">cancel</mat-icon>
                </div>

                <div *ngIf="postDetails?.isMyPost == false">
                    <!-- <mat-icon class="threeDotsColor pointer">priority_high</mat-icon> -->
                    <span (click)="reportPost()" class="dotCirIcon"><mat-icon
                            class="postIcons">priority_high</mat-icon></span>
                </div>
            </div>

            <!-- <li class="px-4">
                <div class="d-flex pointer" (click)="reportPost()">
                    <span class="dotCirIcon"><mat-icon class="postIcons">priority_high</mat-icon></span>
                    <p class="postP mx-2">{{ 'social.report' | translate }}</p>
                </div>
            </li> -->


            <!-- post header -->

            <!-- post likes etc etc  -->
            <div class="d-flex justify-content-between my-2 px-2">

                <div class="d-flex">
                    <p class="d-flex justify-content-between align-items-center" *ngIf="postDetails?.isMyPost == true">
                        <span><mat-icon class="material-symbols-outlined">visibility_outlined</mat-icon></span>
                        <span class="mx-2 mb-eye">{{postDetails?.viewCount}}</span>
                    </p>
                </div>


                <div class="d-flex pointer" *ngIf="postDetails?.isMyPost == true || app?.IsSocialMediaManager">
                    <p (click)="deleteStory()" class="d-flex justify-content-between align-items-center">
                        <span><mat-icon class="deleteBtn">cancel</mat-icon></span>
                        <span class="mx-1 mb-eye deleteText">{{ 'social.delete' | translate }}</span>
                    </p>
                </div>


            </div>
            <!-- post likes etc etc  -->

            <div *ngIf="postDetails?.isMyPost == false" class="mb-3">
                <div class="d-flex justify-content-start">
                    <div class="d-flex align-items-center">
                        <img class="creator-comments object-cover"
                            [src]="app.getUserImage(postDetails?.creatorPicture)" alt="User Image">

                        <div class="mx-2 d-flex align-items-start">
                            <div>
                                <p class="m-0 CommentatorName">{{postDetails?.creatorName}}</p>
                                <p class="m-0 posterSpech">{{postDetails?.creatorSpeciality}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- view Section -->
            <div class="overFlowH" *ngIf="views?.length > 0 && postDetails?.isMyPost == true">
                <div class="px-3 mb-2" *ngFor="let view of views; let i = index">
                    <div class="d-flex justify-content-start">
                        <div class="d-flex align-items-center">
                            <img class="border-less-comments object-cover"
                                [src]="app.getUserImage(view?.createdByPicture)" alt="User Image">

                            <div class="mx-2 d-flex align-items-start">
                                <div>
                                    <p class="m-0 CommentatorName">{{view?.createdByName}}</p>
                                    <p class="m-0 posterSpech">{{view?.speciality}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- view Section -->


        </div>
    </div>

    <div class="col-8 bg-muted br7 pos-rel p-0">

        <ngx-slick-carousel #slickModal="slick-carousel" [config]="slideConfigureForDoctor"
            (afterChange)="afterChangeSlide($event?.currentSlide)">
            <div ngxSlickItem *ngFor="let story of currentStory?.storiesAttr
            ">
            </div>
        </ngx-slick-carousel>

        <div class="h-100 pos-rel" *ngIf="postDetails?.postMedia[0]">

            <mat-progress-bar *ngIf="barProgress" class="storyBar" color="primary" mode="query">
            </mat-progress-bar>

            <div class="d-flex justify-content-center align-items-center h-100 w-100"
                *ngIf="postDetails?.postMedia[0]?.mediaType == 1">
                <img (load)="handleImages()" (error)="handleImages()" class="responsive-detailed-img"
                    [src]="app?.getImageFile(postDetails?.postMedia[0]?.mediaFilePath)">
            </div>

            <div class="d-flex justify-content-center align-items-center h-100 w-100"
                *ngIf="postDetails?.postMedia[0]?.mediaType == 2">
                <video autoplay (ended)="onVideoEnded()" (play)="onVideoStarted()" controls muted
                    class="responsive-detailed-img" controls>
                    <source [src]="app.getImageFile(postDetails?.postMedia[0]?.mediaFilePath)" type="video/mp4">
                </video>
            </div>
        </div>
    </div>

</div>